import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Label,
  FormGroup,
  Row,
  Col,
  Input,
  Form,
  Button,
  Card,
  CardBody,
  CardFooter,
} from "reactstrap";
import JSCookie from "js-cookie";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import publicIp from "public-ip";
import axios from "axios";
import { useHistory } from "react-router-dom";
// import "./coupon.scss";
// import { API_URL, axios } from "../../../../helpers/authHelper";
import Select from "react-select";
import India from "../states.json";
import { AvForm, AvField } from "availity-reactstrap-validation-safe";
import { getCustomer, displayToastr } from "../../../helper";
const logo =
  "data:image/png;base64,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";

const RenewSubscription = (props) => {
  const history = useHistory();
  useEffect(() => {
    if (!JSCookie.get("andre")) {
      history.push("/login");
    }
  }, []);
  // Final Data storage
  const [finalData, setFinalData] = useState({});
  const [selectedPlan, setSelectedPlan] = useState({});
  const [hasGST, setHasGST] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [IPData, setIPData] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [hasBillingInfo, setHasBillingInfo] = useState(true);

  const getBillingInfo = async (customerDetails) => {
    await axios
      .get(`${process.env.REACT_APP_SUBSCRIPTION_URL}/epaper/billing-info`, {
        headers: {
          token: JSCookie.get("andre"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setHasBillingInfo(true);
        setFinalData({
          ...finalData,
          ...res.data,
          state:
            res?.data?.country?.toLowerCase() === "india"
              ? India?.States?.filter((v) => v.label === res?.data?.state)?.[0]
              : {},
        });
      })
      .catch((err) => {
        setHasBillingInfo(false);
        console.log("err: ", err.response);
        if (err.response.status === 401) {
          displayToastr(
            err?.response?.data?.error ?? "Session expired",
            "Renew Subscription",
            5000,
            "error"
          );
          props.history.push("/login");
        }
      });
  };
  useEffect(() => {
    async function getIPData() {
      const IP = await publicIp.v4();
      await axios
        .get(
          `https://pro.ip-api.com/json/${IP}?fields=country,countryCode,city,zip,regionName,query&key=2tjq7YXrdexnO8N`
        )
        .then((res) => {
          setIPData(res.data);
          setFinalData({
            ...finalData,
            city: res.data?.city,
            state:
              res.data.countryCode === "IN"
                ? India?.States?.filter(
                    (v) => v.label === res.data?.regionName
                  )?.[0]
                : {},
            country: res.data?.country,

            zip_code: res.data?.zip,
          });
        });
    }

    if (!hasBillingInfo) getIPData();
  }, [hasBillingInfo]);
  const [IPDataObj, setIPDataObj] = useState({});
  useEffect(() => {
    async function getIPData() {
      const IP = await publicIp.v4();
      await axios
        .get(
          `https://pro.ip-api.com/json/${IP}?fields=country,countryCode,city,zip,regionName,query&key=2tjq7YXrdexnO8N`
        )
        .then((res) => {
          setIPDataObj(res.data);
        });
    }
    getIPData();
  }, []);
  useEffect(() => {
    let cs = getCustomer();
    if (cs && cs.customer_id) {
      getBillingInfo(cs);
      setCustomerDetails(cs);
    }
    const getPlans = async () => {
      const IP = await publicIp.v4();
      await axios
        .get(
          `${process.env.REACT_APP_SUBSCRIPTION_URL}/subscription-plans/find-by-location-and-customer/?ip=${IP}&tenant=${process.env.REACT_APP_EPAPER_TENANT_ID}`
        )
        .then((res) => {
          let voucher_array = [];
          let array = res.data[0].subscription_plans;
          if (array && array.length > 0) {
            for (let i = 0; i < array.length; i++) {
              const element = array[i];
              voucher_array.push(element.vouchers.length > 0 ? true : false);
            }
          }
          if (voucher_array.length > 0) {
            let filter = voucher_array.filter((v) => v == true);
            if (filter && filter.length > 0) {
              // this.setState({ hasVouchers: true });
            } else {
              // this.setState({ hasVouchers: false });
            }
          } else {
            //   this.setState({ hasVouchers: false });
          }
          setSubscriptionData(res.data[0].subscription_plans);
        });
    };
    getPlans();
  }, []);

  const selectHandler = (item) => {
    setSelectedPlan(item);
  };

  const saveHandler = async () => {
    if (!selectedPlan || Object.keys(selectedPlan).length == 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const body = {
        ...finalData,
        state: finalData?.state?.label,
        customer_id: finalData?.customer_id ?? customerDetails?.customer_id,
      };
      delete body?.customerDetails;
      await axios
        .put(
          `${process.env.REACT_APP_SUBSCRIPTION_URL}/epaper/update-billing-info`,
          body,
          {
            headers: {
              token: JSCookie.get("andre"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (selectedPlan && Object.keys(selectedPlan).length > 0) {
            displayToastr(
              "Billing information updated successfully",
              "Renew Subscription",
              5000,
              "success"
            );
            displayRazorpay(res.data._id);
          } else {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
        })
        .catch((err) => {
          console.log("err: ", err.response);
        });
    }
  };
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const orderFlow = async (billing_info_id) => {
    // creating a new order
    const orderURL = `${process.env.REACT_APP_SUBSCRIPTION_URL}/razorpay/create-order`;
    let obj = {
      amount: selectedPlan?.price,
      currency: selectedPlan?.currency.code,
      currency_id: selectedPlan?.currency._id,
      customer_id: customerDetails?.customer_id,
      plan_id: selectedPlan?._id,
      billing_info_id,
    };
    let total = Number(selectedPlan.price);
    if (IPDataObj.countryCode === "IN") {
      if (finalData?.state?.label === "Maharashtra") {
        let cgst = (9 * Number(selectedPlan.price)) / 100;
        let sgst = (9 * Number(selectedPlan.price)) / 100;
        total = total + cgst + sgst;
        obj.total = Number(total.toFixed(2));
      } else {
        let igst = (18 * Number(selectedPlan.price)) / 100;
        total = total + igst;
        obj.total = Number(total.toFixed(2));
      }
    }
    const rzpResponse = await axios.post(orderURL, obj);
    const order = await rzpResponse.data;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY, //todo change on production
      currency: order.currency,
      amount: order.amount.toString(),
      order_id: order.id,
      name: "The TimesGroup ePaper",
      description: "",
      image: logo,
      handler: async function (response) {
        const data = {
          orderCreationId: order.id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
          customer_id: customerDetails?.customer_id, //todo
          plan_id: selectedPlan?._id,
          currency_id: selectedPlan?.currency._id,
        };
        let total = Number(selectedPlan.price);
        if (IPDataObj.countryCode === "IN") {
          if (finalData?.state?.label === "Maharashtra") {
            let cgst = (9 * Number(selectedPlan.price)) / 100;
            let sgst = (9 * Number(selectedPlan.price)) / 100;
            total = total + cgst + sgst;
            data.total = Number(total.toFixed(2));
            data.taxes = [
              { type: "cgst", tax_rate: 9, tax_amount: cgst },
              { type: "sgst", tax_rate: 9, tax_amount: sgst },
            ];
          } else {
            let igst = (18 * Number(selectedPlan.price)) / 100;
            total = total + igst;
            data.total = Number(total.toFixed(2));
            data.taxes = [{ type: "igst", tax_rate: 9, tax_amount: igst }];
          }
        }
        const successURL = `${process.env.REACT_APP_SUBSCRIPTION_URL}/razorpay/success-order`;
        const result = await axios.post(successURL, data);
        if (result.status === 200) {
          displayToastr(
            "Subscription renewed successfully",
            "Renew Subscription",
            5000,
            "success"
          );
          console.log("Redirect to Success page");
          window.location.assign(`/payment-status/${order.id}`);
        } else alert("Redirect to Failure page");
      },

      prefill: {
        name: finalData?.full_name,
        email: finalData?.customerDetails?.email,
        contact: finalData?.customerDetails?.mobile,
      },
      readonly: {
        email: true,
        contact: true,
      },
      theme: {
        color: "#61dafb",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  async function displayRazorpay(billing_info_id) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    orderFlow(billing_info_id);
  }
  return (
    <Fragment>
      <div className="d-flex justify-content-center py-3">
        <div className="ad_div"></div>
        <div style={{ borderLeft: "4px solid #be3144" }}>
          <div className="d-flex ml-4 text-muted">
            <Col md="12" sm="10" className="px-0">
              <Nav className="secondary_nav_tabs" tabs>
                <NavItem className="col-sm-12 px-0">
                  <NavLink
                    className={`${classnames({
                      active: true,
                    })} secondary_nav_tab_link pl-0 ml-0`}
                  >
                    <h5>Subscription</h5>
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </div>
          <div className="d-flex ml-4 text-muted my-2">
            <Col md="12" sm="10" className="px-0">
              <h4>Choose a subscription plan</h4>
            </Col>
          </div>
          <Row className="ml-4">
            <Col md="8" sm="10" className="px-0">
              <Row>
                {subscriptionData &&
                  subscriptionData.map((item, index) => {
                    let discount = item.dummy_price - item.price;
                    return (
                      <Fragment key={item._id + index}>
                        <Col
                          md={subscriptionData.length > 3 ? 3 : 4}
                          sm="6"
                          className="mb-2"
                        >
                          <Card
                            style={{
                              height: "400px",
                              cursor: "pointer",
                              opacity:
                                selectedPlan &&
                                Object.keys(selectedPlan).length > 0 &&
                                selectedPlan._id !== item._id
                                  ? 0.5
                                  : 1,
                              border:
                                selectedPlan &&
                                Object.keys(selectedPlan).length > 0 &&
                                selectedPlan._id === item._id &&
                                "2px solid #be3144",
                            }}
                            onClick={() => {
                              selectHandler(item);
                            }}
                          >
                            <CardBody className="d-flex flex-column align-items-center text-center">
                              <h5>
                                {item.display_name} -{" "}
                                <span className="text-capitalize">
                                  {item.duration}
                                </span>
                              </h5>
                              <h5
                                className="mt-2"
                                style={{
                                  textDecoration: "line-through",
                                  color: "#be3144",
                                }}
                              >
                                {item.dummy_price}/-{item.currency.code}
                              </h5>
                              <h5 className="mt-2">
                                {Math.round(item?.price)}
                                /-{item.currency.code}
                              </h5>
                              {/* {item.discount > 0 ? (
                                <div
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    background: "#be3144",
                                  }}
                                  className="text-white d-flex flex-column ml-4 align-items-center rounded-circle mt-4"
                                >
                                  <p className="mb-0">Save</p>
                                  <p className="mb-0">{item.discount}%</p>
                                </div>
                              ) : null} */}
                              {discount &&
                                discount > 0 &&
                                item.dummy_price &&
                                item.dummy_price !== 0 && (
                                  <div className="discount">
                                    Save <br />
                                    {(
                                      (discount / item.dummy_price) *
                                      100
                                    ).toFixed(0) + "%"}
                                  </div>
                                )}
                            </CardBody>
                            <CardFooter className="border-0 text-center">
                              {selectedPlan && selectedPlan._id === item._id ? (
                                <span
                                  style={{ color: "#be3144" }}
                                  className="font-weight-bold"
                                >
                                  Selected
                                </span>
                              ) : (
                                <span style={{ color: "#be3144" }}>
                                  Subscribe
                                </span>
                              )}
                            </CardFooter>
                          </Card>
                        </Col>
                      </Fragment>
                    );
                  })}
              </Row>
            </Col>
          </Row>
          {IPDataObj && IPDataObj.countryCode === "IN" && (
            <Row className="mt-5 ml-4">
              <Col md="12" sm="10">
                <ul className="list-unstyled small">
                  <li style={{ color: "#be3144" }}>* Taxes are applicable</li>
                  <li style={{ color: "#be3144" }}>
                    ** The Partner's terms and conditions and guidelines shall
                    be applicable on the redemption of vouchers/offers/discounts
                  </li>
                </ul>
              </Col>
            </Row>
          )}
          <Row className="ml-4 justify-content-center">
            <span className="col col-md-5 pl-0">
              <hr />
            </span>
            <span className="d-flex align-items-center px-0">
              <p className="mb-0 mx-4">OR</p>
            </span>
            <span className="col col-md-5 pr-0">
              <hr />
            </span>
          </Row>

          <AvForm onValidSubmit={saveHandler} className="d-flex ml-4">
            <Col md="12" sm="10" className="px-0">
              <h5>
                Please provide the billing details to proceed to payment page
              </h5>

              <AvField
                type="text"
                value={finalData?.full_name ?? ""}
                name="name"
                placeholder="Enter your Full Name"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({ ...finalData, full_name: e.target.value });
                }}
                label="Full Name"
                grid={{ lg: 9, md: 9, sm: 9 }}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Enter your Full Name",
                  },
                }}
              />

              <AvField
                type="text"
                value={finalData?.address_line_1 ?? ""}
                name="address_line_1"
                placeholder="Enter your Address Line 1"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({
                    ...finalData,
                    address_line_1: e.target.value,
                  });
                }}
                label="Address 1"
                grid={{ lg: 9, md: 9, sm: 9 }}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Enter your Address Line 1",
                  },
                }}
              />

              <AvField
                type="text"
                value={finalData?.address_line_2 ?? ""}
                name="address_line_2"
                placeholder="Enter your Address Line 2 - Optional"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({
                    ...finalData,
                    address_line_2: e.target.value,
                  });
                }}
                label="Address 2"
                grid={{ lg: 9, md: 9, sm: 9 }}
              />

              <AvField
                type="text"
                value={finalData?.zip_code ?? ""}
                name="zip_code"
                placeholder="Enter your Zip code"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({ ...finalData, zip_code: e.target.value });
                }}
                label="Zip Code"
                grid={{ lg: 9, md: 9, sm: 9 }}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Enter your Zip code",
                  },
                }}
              />

              <AvField
                type="text"
                value={finalData?.city ?? ""}
                name="city"
                placeholder="Enter your City"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({ ...finalData, city: e.target.value });
                }}
                label="City"
                grid={{ lg: 9, md: 9, sm: 9 }}
                validate={{
                  required: { value: true, errorMessage: "Enter your City" },
                }}
              />
              <FormGroup tag={Row}>
                <Col md={3}>State</Col>
                <Col md={9}>
                  <Select
                    value={finalData?.state ?? {}}
                    name="state"
                    placeholder="Select your State"
                    className="customInput form-control-label"
                    onChange={(e) => {
                      setFinalData({ ...finalData, state: e });
                    }}
                    label="State"
                    options={India?.["States"]}
                    getOptionLabel={(option) => {
                      return option.label;
                    }}
                    getOptionValue={(option) => {
                      return option;
                    }}
                  />
                </Col>
              </FormGroup>
              <AvField
                type="text"
                value={finalData?.country ?? ""}
                name="country"
                placeholder="Enter your Country"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({ ...finalData, country: e.target.value });
                }}
                label="Country"
                grid={{ lg: 9, md: 9, sm: 9 }}
                validate={{
                  required: { value: true, errorMessage: "Enter your Country" },
                }}
              />

              <AvField
                type="text"
                value={finalData?.gst ?? ""}
                name="gst"
                placeholder="Enter your GST Number"
                className="customInput form-control-label"
                onChange={(e) => {
                  setFinalData({
                    ...finalData,
                    gst_number: e.target.value,
                  });
                  if (e?.target?.value?.length > 0) {
                    setHasGST(true);
                  }
                }}
                validate={{
                  pattern: {
                    value:
                      /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/,
                    errorMessage:
                      "GST Number does not belong to state selected",
                  },
                }}
                label="GST Number"
                grid={{ lg: 9, md: 9, sm: 9 }}
              />
              {hasGST && (
                <AvField
                  type="text"
                  value={finalData?.business_name ?? ""}
                  name="business_name"
                  placeholder="Enter your Business name"
                  className="customInput form-control-label"
                  onChange={(e) => {
                    setFinalData({
                      ...finalData,
                      business_name: e.target.value,
                    });
                  }}
                  label="Business name"
                  grid={{ lg: 9, md: 9, sm: 9 }}
                  validate={{
                    required: {
                      value: hasGST ? true : false,
                      errorMessage: "Enter your Business name",
                    },
                  }}
                />
              )}
              <Col md="12" className="px-0">
                <AvField
                  autocomplete="off"
                  type="checkbox"
                  name="termsCheckBox"
                  className="customInput form-control-label"
                  defaultChecked={true}
                  label="I accept the legal notes and privacy notes and confirm the use
                  of my data."
                  onChange={(e) => {
                    setFinalData({
                      ...finalData,
                      hasAcceptedTerms: e.target.value,
                    });
                  }}
                />
              </Col>
              {/* <Col md="12" className="px-0">
                <AvField
                  autocomplete="off"
                  type="checkbox"
                  name="optForSubscription"
                  className="customInput form-control-label"
                  defaultChecked={false}
                  label="Opt for subscription renewal"
                  onChange={(e) => {
                    setFinalData({
                      ...finalData,
                      optForSubscription: e.target.value,
                    });
                  }}
                />
              </Col> */}
              <Row>
                <Col
                  className="d-flex justify-content-end align-items-center"
                  md="12"
                >
                  <Button
                    type="submit"
                    size="sm"
                    style={{
                      background: "#be3144",
                      border: "1px solid #be3144",
                      color: "#fff",
                    }}
                  >
                    Proceed to Payment
                  </Button>
                </Col>
              </Row>
              <Row className="mt-5">
                <Col className="px-0" md="12" lg="12" xl="6">
                  {/* <Label
                    style={{
                      color: "#be3144",
                    }}
                  >
                    <u className="font-weight-bold">About ePaper</u>
                  </Label> */}
                  <ul className="list-unstyled small">
                    {/* <ul className="list-unstyled border-top small"> */}
                    <li>
                      For help write to us on:{" "}
                      <a href="mailto:epaper.support@timesgroup.com">
                        epaper.support@timesgroup.com
                      </a>
                    </li>
                    <li>
                      For Bulk Subscription queries write to us on: <br />
                      <a href="mailto: bulk.epapersub@timesgroup.com">
                        bulk.epapersub@timesgroup.com
                      </a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </AvForm>
        </div>
      </div>
    </Fragment>
  );
};

export default RenewSubscription;
